import axios from 'axios'

export const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:8001/api/'
export const BACK_URL = process.env.VUE_APP_BACK_URL || 'http://localhost:8001/'

const http = axios.create({
  baseURL: API_URL,
})

http.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/'
    }
    return Promise.reject(error)
  }
)

export default http
